module.exports = __webpack_public_path__ + "static/media/img2.bc26b854.jpg";